import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import { Modal, ModalControls } from '../../../../../components/Modal';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_UPDATE_SELECTED_VEHICLES } from '../../../constants';
import { Cell } from '../../../../KanbanBoards/cells/Cell';
import { BaseCellComp } from '../../../../KanbanBoards/cells/BaseCellComp';
import {
  addVehicleToBulkActionsList,
  bulkActionAssignVehicleTransport,
  removeVehicleFromBulkActionsList,
  updateSelectedVehicles,
} from '../../../actions';
import { refreshBoards } from '../../../../KanbanBoards/actions';
import { HBox } from '../../../../../components/Box';
import { swapKeyValues } from '../../../../../utils/object';
import { VehiclePropertyEditableInput } from '../../../components/VehiclePropertyEditableInput';

//change this for values of counters

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  NONE: '0',
  Extern_transport: '1',
  Alwin_ter_Schure: '2',
  John_van_de_Berg: '3',
  Matthijs_Nijkamp: '4',
  Dirk: '5',
  Harry_Nijboer: '6',
  Overig_intern: '7',
  Wachten_op_transport: '8',
};

export const TransportAssignableSortMap = swapKeyValues(TransportAssignable);
export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class Transport_1_nl_in_BulkActionComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.props.reset();
  }

  get action() {
    return this.props.action;
  }

  renderApprove() {
    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_1_nl_in.modal.incoming_transport_plan')}
      >
        <HBox flexWrap center>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            {this.state.selected === '1' && (
              <div>
                <VehiclePropertyEditableInput
                  propertyName="transporter_extern"
                  vehicleIds={this.props.vehicleIds}
                  updateCallback={() => this.setState({ selected: null })}
                />
              </div>
            )}
          </div>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <br />

            {TransportAssignableOptions.map(a => (
              <Button
                primary={a.value == this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label.replace(/\_/g, ' ')}
              </Button>
            ))}
          </div>
        </HBox>
        <ModalControls>
          {this.props.workVehiclesEdit || this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <Button
                primary
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </Button>
              {/* <Button alert onClick={() => this.props.done(this.reset.bind(this))}>
                {this.lbl('Complete')}
              </Button> */}
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return <Cell>{this.renderApprove()}</Cell>;
  }
}

Transport_1_nl_in_BulkActionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workVehiclesEdit: selectWork(REQUEST_UPDATE_SELECTED_VEHICLES),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
    //
    assign(id, callback) {
      dispatch(
        bulkActionAssignVehicleTransport(ownProps.vehicleIds, `${id}`, false, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    updateSelectedVehicles(properties, callback) {
      dispatch(updateSelectedVehicles(ownProps.vehicleIds, properties, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_1_nl_in_BulkAction = compose(withConnect, withRouter)(Transport_1_nl_in_BulkActionComp);
